import FAQTable from "./components/faq-table/FAQTable";

const FaqTables = () => {
  return (
    <div>
      <div className="mt-5 grid h-full grid-cols-1 gap-5 md:grid-cols-1">
        <FAQTable />
      </div>
    </div>
  );
};

export default FaqTables;
